import CampaignInformation from '@extension/context/content/components/bt-bulk-dashboard/campaign-information';

import RowStack from "@common-components/common/row-stack/RowStack";
import { selectCampaignPendingMessageCountByCampaignId } from "@common-reducers/CampaignSelectors";
import { clearAllPendingCampaignMessagesThunk, sendAllPendingCampaignMessagesThunk } from '@common-reducers/CampaignThunks';
import { DBBoardsThunks, DBMessageLogThunks, DBUserMessageThunks, campaignsSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { CancelOutlined, MoreVert, SendOutlined } from "@mui/icons-material";
import { IconButton, Menu } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';


type Props = {
    itemId: string;
    index: number;
};

export default function PendingCampaignRow({ itemId, index }: Props) {
    const dispatch = useAppDispatch()
    const { t } = useTranslation(namespace);
    const campaign = useAppSelector(state => campaignsSelectOneObjectByQuery(state.DBCampaignReducer, {
        $or: [{ deleted: { $exists: false } }, { deleted: false }],
        _id: itemId
    }));
    const numberOfPendingMessages = useAppSelector(state => selectCampaignPendingMessageCountByCampaignId(state, campaign?._id ?? ''))

    const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState<null | HTMLElement>(null);





    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setActionMenuAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => setActionMenuAnchorEl(null);


    const handleClickSendNow = () => {
        dispatch(sendAllPendingCampaignMessagesThunk({ campaignId: itemId }))
        handleCloseMenu()
    }

    const handleClickClearMessages = () => {

        dispatch(clearAllPendingCampaignMessagesThunk({ campaignId: itemId }))
        //dispatch(calculateCampaignStatisticsThunk({ campaignId: itemId }))
        handleCloseMenu()
    }

    const actionMenu = () => {

        return (
            <>
                <IconButton onClick={handleOpenMenu}
                    sx={{
                        marginLeft: '15px',
                        color: '#7f9887',
                        width: 'auto',
                        p: 0,
                        '&:hover': {
                            backgroundColor: '#ecfceb',
                        },
                    }}>
                    <MoreVert />
                </IconButton>
                <Menu
                    anchorEl={actionMenuAnchorEl}
                    keepMounted
                    open={Boolean(actionMenuAnchorEl)}
                    onClose={handleCloseMenu}
                    PaperProps={{
                        style: {
                            borderRadius: '6px',
                            boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.05)',
                        },
                    }}
                    MenuListProps={{
                        sx: {
                            padding: 0, // Attempting to target the padding directly
                            // If the above doesn't work, you might need a more specific target using global selectors
                            '& .MuiList-root': {
                                padding: 0, // This is a more targeted approach
                            },
                        },
                    }}
                >
                    <Box className="w-[245px] bg-[var(--color-surface)] dark:bg-[var(--color-surface)] border border-[var(--color-border)] dark:border-[var(--color-border)] rounded-[10px] shadow-[0_5px_12px_rgb(0_55_80_/_16%)]">
                        <button onClick={handleClickSendNow} className="cursor-pointer text-sm flex items-center w-[94%] py-1.5 px-2.5 m-2 border-0 outline-none bg-transparent rounded-md text-[var(--color-text)] dark:text-[var(--color-text)] hover:bg-[var(--color-surface-muted)] dark:hover:bg-[var(--color-surface-muted)]">
                            <SendOutlined />
                            <span className="ml-1.25">{t('campaign.sendNow', { defaultValue: 'Send now' })}</span>
                        </button>
                        <button onClick={handleClickClearMessages} className="cursor-pointer text-sm flex items-center w-[94%] py-1.5 px-2.5 m-2 border-0 outline-none bg-transparent rounded-md text-[var(--color-text)] dark:text-[var(--color-text)] hover:bg-[var(--color-surface-muted)] dark:hover:bg-[var(--color-surface-muted)]">
                            <CancelOutlined />
                            <span className="ml-1.25">{t('campaign.stopAndDeletePending', { defaultValue: 'Stop and delete pending' })}</span>
                        </button>
                    </Box>
                </Menu>
            </>
        )
    }

    useEffect(() => {
        dispatch(DBBoardsThunks.find({
            deleted: false,
            type: 'audience',
            $paginate: false,
        }))
        dispatch(DBUserMessageThunks.find({ campaignId: itemId }))
        dispatch(DBMessageLogThunks.find({ campaignId: itemId }))
    }, [])


    return (
        <RowStack key={index}
            sx={{
                justifyContent: 'space-between',
                borderBottom: '1px solid var(--color-border)',
                height: "112px",
                padding: '10px 10px 10px 10px',
                width: '100%',
                boxSizing: 'border-box',
            }}>
            <CampaignInformation
                campaignId={campaign?._id ?? ''}
                width={'70%'}
                showSentProgress={true}
            />
            <RowStack sx={{ justifyContent: 'space-around' }}>
                <Stack sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{
                        color: 'var(--status-badge-text)',
                        backgroundColor: 'var(--status-badge-bg)',
                        border: '1px solid var(--status-badge-border)',
                        width: '66px',
                        height: '24px',
                        borderRadius: '6px',
                        fontSize: '13px',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '2px 7px 5px 7px'
                    }}>
                        {numberOfPendingMessages}&nbsp;Pending
                    </div>
                </Stack>
                {actionMenu()}
            </RowStack>
        </RowStack>
    )
}